import { Box, ColorOptions, ModBox, Text, TextNew, TextProps } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../../../data/store'
import { styles } from './styles'

interface CountDownTimerProps {
  count?: number
  mobile?: string
}

const cdtStyles = (resendOtpColor: string) => {
  return {
    resendText: {
      fontSize: 12,
      fontFamily: 'jiotype-medium',
      color: resendOtpColor,
    } as TextProps,
  }
}

const getCountDownTime = (cdtimer: number) => {
  return cdtimer > 0 ? (cdtimer < 10 ? `( 0${cdtimer}` : `( ${cdtimer}`) : ''
}

const CountDownTimer: FC<CountDownTimerProps> = ({ count = 0, mobile }: CountDownTimerProps) => {
  const { generateOtp } = useStores((root) => ({
    generateOtp: root.agentQrUser.generateOtp,
  }))

  const [countDowntimer, setCountDownTimer] = useState(count)
  const [resendOtp, { data }] = useLazyApiData(generateOtp)
  const error = data?.message ?? ''

  useEffect(() => {
    let timer: any
    if (countDowntimer > 0) {
      timer = setInterval(() => setCountDownTimer(countDowntimer - 1), 1000)
    }
    return () => clearInterval(timer)
  }, [countDowntimer])

  const resendOtpColor = countDowntimer > 0 ? ('BLACK_75' as ColorOptions) : ('BLUE' as ColorOptions)

  const onResendOtp = () => {
    if (countDowntimer <= 0) {
      setCountDownTimer(30)
      if (mobile?.length === 10) {
        resendOtp(mobile)
      }
    }
  }

  return (
    <Box onPress={onResendOtp} testID="resend-otp" {...styles.resendTouchable} underlayColor={'TRANSPARENT'}>
      <ModBox show={error?.length > 0}>
        <TextNew type={'bodyMedium14'} color={'ERROR'}>
          {error}
        </TextNew>
      </ModBox>
      <Box {...styles.resendContainer}>
        <Text {...cdtStyles(resendOtpColor).resendText}>{'Resend OTP'}</Text>
        <Text {...styles.countStyle}>{' ' + getCountDownTime(countDowntimer)}</Text>
        <Text {...styles.secondStyle}>{`${countDowntimer !== 0 ? 's )' : ''}`}</Text>
      </Box>
    </Box>
  )
}

export default CountDownTimer
